import React, { useRef } from "react";
import { Trees, Plus, Settings } from "lucide-react";

const badgeStyles = {
  on: {
    container: "bg-emerald-500/10 border-emerald-500/30 text-emerald-400",
    dot: "bg-emerald-500 animate-ping",
    text: "Dinleniyor...",
  },
  off: {
    container: "bg-slate-700 border-slate-600 text-slate-400",
    dot: "bg-slate-500",
    text: "Ses Kapalı",
  },
  unsupported: {
    container: "bg-red-500/10 border-red-500/30 text-red-400",
    dot: "bg-red-500",
    text: "Desteklenmiyor",
  },
};

export default function Header({ logo, onLogoUpload, voiceState, onToggleVoice, onOpenSettings }) {
  const fileRef = useRef(null);
  const badge = badgeStyles[voiceState] || badgeStyles.on;

  const handleFile = (event) => {
    const file = event.target.files && event.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = function (e) {
      onLogoUpload(e.target.result);
      event.target.value = "";
    };
    reader.readAsDataURL(file);
  };

  return (
    <header className="bg-slate-800 border-b border-slate-700 p-4 sticky top-0 z-50 shadow-md shrink-0">
      <div className="max-w-md mx-auto flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div
            className="relative group cursor-pointer"
            onClick={() => fileRef.current && fileRef.current.click()}
            title="Galeriden Resim Yükle"
          >
            <div className="w-12 h-12 rounded-xl bg-brand-600/20 border-2 border-brand-500 flex items-center justify-center text-brand-400 overflow-hidden shadow-lg transition-all active:scale-95">
              {logo ? (
                <img src={logo} className="w-full h-full object-cover" alt="Logo" />
              ) : (
                <Trees size={20} />
              )}
            </div>
            <div className="absolute -bottom-1 -right-1 bg-slate-900 text-brand-400 w-5 h-5 rounded-full flex items-center justify-center border border-slate-700 shadow">
              <Plus size={10} />
            </div>
          </div>
          <div>
            <h1 className="font-bold text-base text-white leading-tight">Ragıp Paşa Korusu</h1>
            <p className="text-[11px] text-slate-400">Kayıtlı Kişiler</p>
          </div>
        </div>

        <div className="flex items-center gap-2">
          <div
            onClick={onToggleVoice}
            className={`cursor-pointer flex items-center justify-center gap-2 border px-4 py-1.5 rounded-full text-xs font-medium transition-colors active:scale-95 min-w-[115px] ${badge.container}`}
            title="Sesli Komutu Aç/Kapat"
          >
            <span className={`w-2.5 h-2.5 rounded-full shrink-0 ${badge.dot}`}></span>
            <span className="whitespace-nowrap">{badge.text}</span>
          </div>
          <button
            onClick={onOpenSettings}
            className="w-9 h-9 rounded-full bg-slate-700 hover:bg-slate-600 border border-slate-600 text-slate-300 flex items-center justify-center transition-colors active:scale-95 shadow-sm shrink-0"
            title="Ayarlar"
          >
            <Settings size={16} />
          </button>
        </div>
      </div>

      <input type="file" ref={fileRef} accept="image/*" className="hidden" onChange={handleFile} />
    </header>
  );
}
